import Tabs from './tabs';
import Pane from './pane';

Tabs.TabsPane = Pane;

export default Tabs;
